import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export const useLeagueMemberCount = (leagueId?: string) => {
  const [count, setCount] = useState<number>(0);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!leagueId) {
      setCount(0);
      setIsLoading(false);
      return;
    }

    fetchMemberCount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [leagueId]);

  const fetchMemberCount = async () => {
    if (!leagueId) return;

    try {
      setIsLoading(true);
      
      const { count: memberCount, error } = await supabase
        .from('league_memberships')
        .select('*', { count: 'exact', head: true })
        .eq('league_id', leagueId)
        .eq('status', 'active');

      if (error) {
        console.error('Error fetching member count:', error);
        setError('Failed to fetch member count');
        return;
      }

      setCount(memberCount ?? 0);
      setError(null);
    } catch (err) {
      console.error('Error fetching member count:', err);
      setError('Failed to fetch member count');
    } finally {
      setIsLoading(false);
    }
  };

  return { count, isLoading, error, refetch: fetchMemberCount };
};

